import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header = ({ onNewWorkflow }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <div className="logo">
            <i className="fas fa-film"></i>
            <span className="logo-text">Cartoon Movie Studio</span>
          </div>
          <p className="tagline">AI-Powered Movie Creation Platform</p>
        </div>

        <div className="header-center">
          <button className="btn btn-primary" onClick={onNewWorkflow}>
            <i className="fas fa-plus"></i>
            New Workflow
          </button>
        </div>

        <div className="header-right">
          {user && (
            <div className="user-info">
              <div className="user-avatar">
                <i className="fas fa-user"></i>
              </div>
              <div className="user-details">
                <span className="user-name">{user.name}</span>
                <span className="user-email">{user.email}</span>
              </div>
              <button className="btn btn-secondary logout-btn" onClick={handleLogout}>
                <i className="fas fa-sign-out-alt"></i>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
